export { default } from './PostsBlock';
